import React from 'react';
import PropTypes from 'prop-types';

const ControllerContainer = (props) => {
	const { isInlineOrRowLayout, children } = props;

	const TagName = isInlineOrRowLayout ? 'div' : React.Fragment;

	return (
		<TagName className="d-flex facet-controller align-items-center">
			{children}
		</TagName>
	);
};

ControllerContainer.propTypes = {
	children: PropTypes.element.isRequired,
	isInlineOrRowLayout: PropTypes.bool
};

export default ControllerContainer;
